module.exports = __webpack_public_path__ + "static/media/sb.d57639ee.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/video/sb.mov
// module id = 535
// module chunks = 0